import { CommonModule, NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';

interface Providers {
  providerTradeName: string;
  providerEmail: string;
  providerRfc: string;
  providerPhone: string;
  providerAddress: string;
  providerStatus: string;

}

@Component({
  selector: 'app-provider-page',
  imports: [NgIf, CommonModule],
  templateUrl: './provider-page.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProviderPageComponent { 
  providers: Providers[] = [];
  showFilterModal = false;

  openModal(){

  }
}
